import { toUnicode } from "../utils/DomainUtils";

const createFullUrl = (site, includeProtocol = false, page = false) => {
  if (site && site.get("domain", false)) {
    let domain = site.get("domain", false);
    const isNotHome = page && !page.get("home");
    const slug = page && page.get("slug");
    const wwwRequired = site.getIn(["domain_info", "www_required"], false);
    const sslRequired = site.getIn(["domain_info", "ssl_enabled"], false);
    domain = (wwwRequired ? "www." : "") + toUnicode(domain || "");
    const publishDomainProtocol = sslRequired ? "https:" : "http:";
    return `${includeProtocol ? publishDomainProtocol + "//" : ""}${domain}${
      slug && isNotHome ? "/" + slug : ""
    }`;
  }
};

export default {
  createFullUrl,
};
